export default "__VITE_ASSET__dbd1f70d__"